<template>
  <div class="index">
    <div class="nav1">
      <div class="tit1">岗位职级前缀关键词</div>
    </div>
    <div class="nav2">
      <div class="myForm">
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <el-col :span="20">
              <el-form-item label="岗位职级前缀关键词：">
                <el-input type="textarea" v-model="ruleForm.post_zj_pre_allows" :rows="10" placeholder="请输入岗位职级前缀关键词，多个关键词用英文逗号分隔"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button style="margin-top:10px" icon="el-icon-s-promotion" size="small" type="primary" @click="submitForm">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        post_zj_pre_allows: ""
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await this.$api.crudselectonebyid({
        table: 'systems',
        id: 1,
        columns: 'post_zj_pre_allows'
      });
      if (res.data && res.data.data && res.data.data.post_zj_pre_allows) {
        this.ruleForm.post_zj_pre_allows = res.data.data.post_zj_pre_allows;
      }
    },
    // 提交
    async submitForm() {
      const res = await this.$api.crudupdatebyid({
        table: 'systems',
        id: 1,
        values: {
          post_zj_pre_allows: this.ruleForm.post_zj_pre_allows
        }
      });
      
      if (res.data && res.data.result == 1) {
        this.$message({
          message: res.data.msg || '保存成功',
          type: "success"
        });
        this.getData();
      } else {
        this.$message.error(res.data ? res.data.msg : '保存失败');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.index {}

.nav1 {
  margin: 0 -18px;
  background-color: #fff;
  padding: 20px 32px 0 40px;

  .tit1 {
    color: #17233d;
    font-weight: 500;
    font-size: 20px;
    padding-bottom: 20px;
  }
}

.nav2 {
  margin: 18px 0;
  background: #fff;
  border-radius: 6px;
  padding: 24px;

  .myForm {
    ::v-deep .el-form-item__label {
      font-size: 12px;
    }

    ::v-deep .el-form-item {
      margin-right: 30px;
      margin-bottom: 20px;
    }
  }
}
</style> 